import React from 'react';
import TranslationUtil from '../util/translation';
import I18nContext from '../i18n/I18nContext';

export default function translate(key) {
    return (Component) => {
        class TranslationComponent extends React.Component {
            render() {
                return (
                    <I18nContext.Consumer>
                        {(i18nContext) => {
                            const language = i18nContext.i18nTheme.get();
                            const strings =
                                TranslationUtil.getTranslationsForContext(
                                    key,
                                    language
                                );
                            return (
                                <Component
                                    {...this.props}
                                    {...this.state}
                                    strings={strings}
                                />
                            );
                        }}
                    </I18nContext.Consumer>
                );
            }
        }

        return TranslationComponent;
    };
}
